import { create } from "zustand";

export type Theme = "light" | "dark";

export function applyTheme(theme: Theme) {
  const el = document.documentElement;
  if (theme === "dark") el.classList.add("dark");
  else el.classList.remove("dark");
}

const storedTheme = ((): Theme => {
  try {
    return (localStorage.getItem("assortiq_theme") as Theme) || "light";
  } catch {
    return "light";
  }
})();

interface UiState {
  theme: Theme;
  sidebarCollapsed: boolean;
  paletteOpen: boolean;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;
  toggleSidebar: () => void;
  setPaletteOpen: (v: boolean) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  theme: storedTheme,
  sidebarCollapsed: false,
  paletteOpen: false,
  setTheme: (t) => {
    try {
      localStorage.setItem("assortiq_theme", t);
    } catch {}
    applyTheme(t);
    set({ theme: t });
  },
  toggleTheme: () => {
    const next: Theme = get().theme === "dark" ? "light" : "dark";
    get().setTheme(next);
  },
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setPaletteOpen: (v) => set({ paletteOpen: v }),
}));
